var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgc"},[_c('div',{staticClass:"downlaod",on:{"click":_vm.download}},[_c('img',{attrs:{"src":require("../assets/img/mchDownload.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }